import { Controller } from "@hotwired/stimulus";
import ClipboardJS from "clipboard";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";

export default class extends Controller {
  static targets = ["input", "button"];
  static values = {
    title: String,
  };

  connect() {
    console.log("CopyButtonController connected");
    this.clipboard = new ClipboardJS(this.buttonTarget);
    this.clipboard.on("success", this.handleSuccess.bind(this));

    // Initialize tippy
    this.tippyInstance = tippy(this.buttonTarget, {
      content: this.titleValue || "Copy to Clipboard",
      trigger: "manual",
      placement: "top",
      animation: "scale",
      duration: 200,
      theme: "light",
    });
  }

  disconnect() {
    this.clipboard.destroy();
    this.tippyInstance.destroy();
  }

  handleSuccess(e) {
    e.clearSelection();

    // Show "Copied" tooltip
    this.tippyInstance.setContent("Copied!");
    this.tippyInstance.show();

    // Reset after 2 seconds
    window.setTimeout(() => {
      this.tippyInstance.setContent(this.titleValue || "Copy to Clipboard");
      this.tippyInstance.hide();
    }, 2000);
  }
}
